module.exports = __webpack_public_path__ + "static/media/blackRepeat.aa5cf766.svg";